import { motion } from 'framer-motion';
import { useMemo } from 'react';
import { useApp } from '../../contexts/AppContext';

interface GodRaysProps {
    houseId: string;
}

export default function GodRays({ houseId }: GodRaysProps) {
    const { getHouse } = useApp();
    const house = getHouse(houseId);

    const rays = useMemo(() => [...Array(6)], []);

    if (!house) return null;

    return (
        <div className="absolute inset-0 overflow-hidden pointer-events-none z-0">
            {/* Light Source Glow */}
            <div
                className="absolute -top-[20%] -left-[10%] w-[50vh] h-[50vh] rounded-full blur-[100px] opacity-40 mix-blend-screen"
                style={{ backgroundColor: house.color }}
            />

            {/* Rays */}
            {rays.map((_, i) => (
                <motion.div
                    key={i}
                    className="absolute top-[-50%] left-[-20%] w-[200vh] h-[20vh] origin-left opacity-30 blur-2xl"
                    style={{
                        background: `linear-gradient(90deg, ${house.color}40 0%, transparent 80%)`,
                        transform: `rotate(${45 + (i * 10)}deg)`,
                        mixBlendMode: 'overlay',
                    }}
                    animate={{
                        rotate: [45 + (i * 10), 40 + (i * 10), 45 + (i * 10)],
                        opacity: [0.2, 0.4, 0.2],
                        scale: [1, 1.1, 1],
                    }}
                    transition={{
                        duration: 8 + i,
                        repeat: Infinity,
                        ease: "easeInOut",
                        delay: i * 0.5,
                    }}
                />
            ))}
        </div>
    );
}
